module.exports = __webpack_public_path__ + "static/img/img(41).98f6629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(41).png
// module id = 9tVx
// module chunks = 1